import React from 'react';
import { Catefory } from '../Icons/CustomIcons';
import { Checkbox } from './Checkbox';
import { IconHeader } from './Dialog';

/**
 * CategorySelect – Kategorien-Auswahl mit Checkboxen.
 *
 * Props:
 *   options      – Array von { value: string, label: string }
 *   selected     – Array der aktuell gewählten Werte
 *   onToggle(v)  – Callback mit dem toggled Wert
 *   fieldInfo    – optionaler Hilfetext für das FieldInfo-Icon
 *
 * Verwendung Filter:
 *   <CategorySelect
 *     options={CATEGORIES.map(c => ({ value: c.slug, label: c.name }))}
 *     selected={filters.categories}
 *     onToggle={(slug) => toggleCategory(slug)}
 *   />
 *
 * Verwendung Formular:
 *   <CategorySelect
 *     options={categories.map(c => ({ value: c, label: c }))}
 *     selected={formData.categories}
 *     onToggle={(cat) => toggleCategory(cat)}
 *     fieldInfo={info.categories}
 *   />
 */
const CategorySelect = ({ options, selected, onToggle, fieldInfo = '' }) => (
  <div className="filter">
    <IconHeader Icon={<Catefory size={16} color="#fff" />} info={fieldInfo}>
      Kategorien
    </IconHeader>
    <div className="filter__box">
      <div className="category-filter__list">
        {options.map(({ value, label }) => (
          <div key={value} className="category-filter__box">
            <Checkbox
              id={`category-${value}`}
              checked={selected.includes(value)}
              onCheckedChange={() => onToggle(value)}
              label={label}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default CategorySelect;
